import React, {useState} from 'react';
import {deleteServiceProviders} from '../../../../services/externalizations/serviceProvidersService';
import {Toast} from '../../../../utils/sweetAlert';
import {getLanguage, t} from 'react-switch-lang';
import Form from 'reactstrap/lib/Form';
import Button from 'reactstrap/lib/Button';
import Swal from 'sweetalert2';

const DeleteServiceProvider = (props) => {
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  const lang = getLanguage();

  const handleSubmit = async (event) => {
    setIsButtonDisabled(true);
    event.preventDefault();
    try {
      const res = await deleteServiceProviders(props?.data?.id)
        Toast.fire({
          icon: "success",
          title: t('message.deleteSuccess2', {
            entity: t('externalization.serviceProvider'),
          })
        });
        props.setRowChanged();
        props.toggleModal();
        setIsButtonDisabled(false);
      } catch (err) {
      if (err?.response?.data?.code === 'service-provider-in-use-exception') {
        Swal.fire({
          text:
            lang === 'eng'
              ? err?.response?.data?.description
              : t('message.serviceProviderInUseException'),
          icon: 'error',
        });
        setIsButtonDisabled(false);
      } else {
        Toast.fire({
          title: t('message.errorApi'),
          icon: 'error',
        });
      }
    }
  };
  return (
    <Form
      onSubmit={(e) => handleSubmit(e)}
      noValidate
      className="d-flex justify-content-between">
      <Button className="primary deleteButton" disabled={isButtonDisabled}>
        {t("buttons.deleteBtn")}{" "}
      </Button>
    </Form>
  );
};

export default DeleteServiceProvider;